import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { ChargeTestParams } from '../charge-test.component';

@Component({
    selector: 'tt-charge-test-view',
    templateUrl: './charge-test-view.component.html',
    styleUrls: ['./charge-test-view.component.css'],
})
export class ChargeTestViewComponent {
    public params: ChargeTestParams;

    constructor(state: StateService) {
        this.params = state.getStateParams() as unknown as ChargeTestParams;
    }
}
